import { apiPost } from "@redriver/cinnamon";

const ActionTypes = {
  Submit: "SHEETS/SUBMIT",
};

export const submitSheet = ({ sheetId }) =>
  apiPost(ActionTypes.Submit, `sheets/${sheetId}/submit`);
